<template>
  <router-view />
</template>

<script>
export default {
  name: 'UmsApplicationsWrapper',
};
</script>
